import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { ActionDialogComponent } from '@shared/components/dialogs/action-dialog/action-dialog.component';
import { AccountTerminationChanged } from '../store/actions/user-account.actions';
import { AccountApiService } from './api/account-api.service';

@Injectable({
  providedIn: 'root',
})
export class UserAccountService {
  constructor(
    private store: Store,
    public dialog: MatDialog,
    public accountApiService: AccountApiService,
  ) {}

  cancelAccount$(options?: {
    confirmationDialog?: boolean;
    successMessage?: boolean;
  }): Observable<any> {
    return this.accountApiService.terminateMyAccount().pipe(
      tap((status) => {
        if (options?.successMessage) {
          this.cancelAccountSuccessMessage();
        }
        this.store.dispatch(
          AccountTerminationChanged({ accountTerminationStatus: status }),
        );
      }),
    );
  }

  cancelAccountSuccessMessage() {
    this.dialog.open(ActionDialogComponent, {
      width: '700px',
      panelClass: 'background-class',
      data: {
        title: 'app.profile.cancelProfile.successModal.title',
        content: 'app.profile.cancelProfile.successModal.content',
        confirmBtnText: 'app.profile.cancelProfile.successModal.closeButton',
      },
    });
  }

  revokeCancelAccount$(options?: {
    confirmationDialog?: boolean;
    submitDialog?: boolean;
  }): Observable<any> {
    const isConfirmed$: Observable<boolean> = options?.confirmationDialog
      ? this.revokeCancelAccountConfirmation$()
      : of(false);

    return isConfirmed$.pipe(
      switchMap((isConfirmed) => {
        return isConfirmed
          ? this.accountApiService.deleteMyAccountTermination().pipe(
              tap((status) => {
                this.store.dispatch(
                  AccountTerminationChanged({
                    accountTerminationStatus: status,
                  }),
                );
              }),
            )
          : of(null);
      }),
    );
  }

  revokeCancelAccountConfirmation$(): Observable<any> {
    return this.dialog
      .open(ActionDialogComponent, {
        width: '700px',
        panelClass: 'background-class',
        data: {
          title: 'app.profile.cancelProfile.revokeModal.title',
          content: 'app.profile.cancelProfile.revokeModal.content',
          cancelBtnText: 'app.profile.cancelProfile.revokeModal.closeButton',
          confirmBtnText: 'app.profile.cancelProfile.revokeModal.confirmButton',
        },
      })
      .afterClosed();
  }
}
